module.exports = __webpack_public_path__ + "static/media/YM67_1.f57c7483.jpg";